import script from "./Header_AS.vue?vue&type=script&setup=true&lang=js"
export * from "./Header_AS.vue?vue&type=script&setup=true&lang=js"

import "./Header_AS.vue?vue&type=style&index=0&id=4912ccd6&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4912ccd6"]])

export default __exports__